export default function ServicesSection() {
  return null;
}
